import ActionCardTitleDesc from './action-card-title-desc';

export default ActionCardTitleDesc;
